import * as queries from './queries';
import * as mutations from './mutations';

export const products = {
  queries: {
    ...queries
  },
  mutations: {
    ...mutations
  }
};
